import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  TextField
} from "@mui/material";
import { Dropdown, DatePicker } from "@fluentui/react"; // Import DatePicker
// Added by Gauri to fix dropdown position issue on 20 Nov 2025
import { DirectionalHint } from "@fluentui/react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import axios from "axios";
import { toast } from "react-toastify";
import AxiosInstance1 from "app/hooks/AxiosInstance/AxiosInstance1";

// Added setSelectedCheckBoxes by Gauri to fix checkbox issue on 18 Mar 2025
const ActionItemTable = ({ selectedItems, setRefresh1, refresh, setShowActionItemTable, stageID, setSelectedCheckBoxes }) => {
  console.log("ActionItemTable stageID", stageID);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const userID = userdata?.employeeId;
  const [priorities, setPriorities] = useState([]);
  const [responsibilities, setResponsibilities] = useState([]);
  const [selectedValues, setSelectedValues] = useState({});
  const [editedDescriptions, setEditedDescriptions] = useState({});

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < Math.ceil(selectedItems.length / itemsPerPage))
      setCurrentPage(currentPage + 1);
  };

  // Fetch dropdown data
  const fetchDropdownData = async () => {
    // Changed dropdown fieldname by Gauri to bind Assigned TO dropdown on 31 Mar 2025
    // const fields = ["priorityid", "responsibility"];

    // Commented and Added by Gauri to fetch correct priority field on 31 Oct 2025
    // const fields = ["priorityid", "customfieldnumeric1"];
    const fields = ["actionpriority", "customfieldnumeric1"];
    const ideaID = selectedItems[0]?.ideaID || "";

    try {
      const fetchData = async (field) => {
        const url = `/api/InitiativeDetail/GetDropDownDetails?IdeaId=${ideaID}&userID=${userID}&FieldName=${field}`;
        const response = await AxiosInstance1.get(url, {
            headers: {
              "Content-Type": "application/json",
              // Authorization: `Bearer ${sessionStorage.getItem("access_token")}`
            }
          }
        );
        return response.data.data.listInitiativeDetailDropDownEntity;
      };

      const results = await Promise.all(fields.map((field) => fetchData(field)));

      setPriorities(results[0] || []);
      setResponsibilities(results[1] || []);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData();
  }, []);

  // Added by Gauri on 20 Nov 2025 - Common calloutProps for all dropdowns
  const commonCalloutProps = {
    // Use bottomAutoEdge which tries to open downward first, then automatically adjusts upward if needed
    directionalHint: DirectionalHint.bottomAutoEdge,
    // Set max height to prevent dropdown from being too large
    calloutMaxHeight: 250,
    // Ensure dropdown stays within viewport bounds
    bounds: typeof window !== 'undefined' ? {
      top: 0,
      left: 0,
      bottom: window.innerHeight,
      right: window.innerWidth
    } : undefined
  };

  // Handle dropdown selection
  const handleDropdownChange = (itemIndex, field, selectedKey) => {
    setSelectedValues((prev) => ({
      ...prev,
      [itemIndex]: { ...prev[itemIndex], [field]: selectedKey }
    }));
  };

  // Handle description change
  const handleDescriptionChange = (index, newValue) => {
    setEditedDescriptions((prev) => ({
      ...prev,
      [index]: newValue
    }));
  };
  const formatDate = (date) => {
    const d = new Date(date); // Parse the ISO date string
    const day = String(d.getDate()).padStart(2, "0"); // Ensure two digits for day
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Ensure two digits for month
    const year = d.getFullYear();
    return `${year}-${month}-${day}`;
  };
  // Handle Save button click
  const handleSave = async () => {
    // Passed employeename by Gauri to bind Submitted by value on 31 Mar 2025
    const userdata = JSON.parse(sessionStorage.getItem("user"));
    const userName = userdata?.userName;

    for (let index = 0; index < selectedItems.length; index++) {
      // Added by Gauri to set assignedTo dropdown value on 11 Apr 2025
      // const assignedTo = selectedValues[index]?.assignedTo || selectedItems[index]?.approver;
      const assignedTo = selectedValues[index]?.assignedTo;
      const dueDate = selectedValues[index]?.dueDate || selectedItems[index]?.responseDate;
      console.log("dueDate", dueDate);
      if (!assignedTo) {
        toast.error(`Assigned To should not be left blank `);
        return;
      }

      if (!dueDate) {
        toast.error(`Due Date should not be left blank`);
        return;
      }
    }

    try {
      // Loop through each selected item and collect the data
      const apiData = await Promise.all(
        selectedItems.map((item, index) => {
          console.log("selectedItems", item);
          const description = editedDescriptions[index] || item.checkListName;
          // Commented and Added setSelectedCheckBoxes by Gauri to pass priority on 18 Mar 2025
          // const priority = selectedValues[index]?.priority || item.prioritizationRating;
          const priority = selectedValues[index]?.priority || "";
          const assignedTo = selectedValues[index]?.assignedTo || item.approver;
          const dueDate = selectedValues[index]?.dueDate || item.responseDate;
          const formattedDueDate = formatDate(dueDate);

          // Added by Gauri to take only name of the approver on 27 Mar 2025
          // const userName = employeeName ? employeeName.split(" ")[0] : "";

          // Construct the API URL with query parameters
          const requestUrl = 
          // Added item.itemName by Gauri to pass itemname instead of ID on 18 Mar 2025
            // window.runtimeConfig.REACT_APP_BASEURL_ACCESS_CONTROL1
          `/api/InitiativeDetail/PostConvertToActionItem?ActionItem=${
            // item.itemID
            item.itemName
          }&Description=${encodeURIComponent(
            description
          // )}&EmployeeID=${userID}&Priority=${priority}&InitiativeID=${item.ideaID}&StageID=${stageID}
          )}&EmployeeID=${assignedTo}&Priority=${priority}&InitiativeID=${item.ideaID}&StageID=${stageID}
          &ExpectedEndDate=${encodeURIComponent(formattedDueDate)}&ItemID=${
            item.itemID
          }&RevisionID=${item.revisionId}&UserName=${encodeURIComponent(
            // item?.approver
            userName
          )}&SubmitterID=${userID}`;

          return AxiosInstance1.post(requestUrl, null, {
            headers: {
              "Content-Type": "application/json",
              // Authorization: `Bearer ${sessionStorage.getItem("access_token")}`
            }
          });
        })
      );

      await Promise.all(apiData);

      setRefresh1(!refresh);
      toast.success("Action Items Converted successfully.");
      // Added by Gauri to Reset selected checkboxes on 18 Mar 2025
      setSelectedCheckBoxes([]);
      setShowActionItemTable((prev) => !prev);
    } catch (error) {
      console.error("Error saving action items:", error);
    }
  };

  return (
    <div>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Save
        </Button>
      </Box>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Action Item</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Priority</TableCell>
            <TableCell>
              Assigned To <span style={{ color: "red" }}>*</span>
            </TableCell>
            <TableCell>
              Due Date <span style={{ color: "red" }}>*</span>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {selectedItems
            .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
            .map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.itemName}</TableCell>

                {/* Editable Description */}
                <TableCell>
                  <TextField
                    value={editedDescriptions[index]}
                    onChange={(e) => handleDescriptionChange(index, e.target.value)}
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={2}
                    placeholder="Edit Description"
                  />
                </TableCell>

                {/* Priority Dropdown */}
                {/* Added by Gauri to select priority on 18 Mar 2025 */}
                {/* Modified by Gauri to fix dropdown position issue on 20 Nov 2025 */}
                <TableCell>
                  <Dropdown
                    placeholder="Select Priority"
                    // selectedKey={selectedValues[index]?.priority || item.prioritizationRating}
                    selectedKey={selectedValues[index]?.priority || ""}
                    options={[
                      { key: "", text: "Select Priority" },
                      ...priorities.map((p) => ({
                        key: p.id.toString(),
                        text: p.name
                      }))
                    ]}
                    onChange={(e, option) => handleDropdownChange(index, "priority", option?.key)}
                    styles={{ root: { minWidth: 200 } }}
                    calloutProps={commonCalloutProps}
                  />
                </TableCell>

                {/* Assigned To Dropdown */}
                {/* Modified by Gauri to fix dropdown position issue on 20 Nov 2025 */}
                <TableCell>
                  <Dropdown
                    placeholder="Select Assigned To"
                    selectedKey={selectedValues[index]?.assignedTo || item.approver}
                    options={[
                      { key: "", text: "Select Assigned To" },
                      ...responsibilities.map((r) => ({
                        key: r.id.toString(),
                        text: r.name
                      }))
                    ]}
                    onChange={(e, option) => handleDropdownChange(index, "assignedTo", option?.key)}
                    styles={{ root: { minWidth: 200 } }}
                    calloutProps={commonCalloutProps}
                  />
                </TableCell>

                {/* Due Date DatePicker */}
                <TableCell>
                  {/* Commented and Added by Gauri to bind DueDate on 18 Mar 2025 */}
                  {/* <DatePicker
                    value={
                      selectedValues[index]?.dueDate &&
                      selectedValues[index]?.dueDate instanceof Date &&
                      !isNaN(selectedValues[index]?.dueDate)
                        ? selectedValues[index]?.dueDate
                        : item.responseDate &&
                          item.responseDate instanceof Date &&
                          !isNaN(item.responseDate)
                        ? item.responseDate
                        : null // Do not prefill if invalid or null
                    }
                    onSelectDate={(date) =>
                      setSelectedValues((prev) => ({
                        ...prev,
                        [index]: { ...prev[index], dueDate: date }
                      }))
                    }
                    placeholder="Select Due Date"
                    formatDate={(date) => {
                      // Format only if date is valid
                      const validDate = date instanceof Date && !isNaN(date);
                      return validDate ? date.toLocaleDateString("en-GB") : "";
                    }}
                  /> */}
                  <DatePicker
                    value={
                      selectedValues[index]?.dueDate instanceof Date && !isNaN(selectedValues[index]?.dueDate)
                        ? selectedValues[index]?.dueDate
                        : item.responseDate
                        ? new Date(item.responseDate) // Convert string to Date
                        : null
                    }
                    onSelectDate={(date) =>
                      setSelectedValues((prev) => ({
                        ...prev,
                        [index]: { ...prev[index], dueDate: date }
                      }))
                    }
                    placeholder="Select Due Date"
                    formatDate={(date) => (date instanceof Date && !isNaN(date) ? date.toDateString() : "")} // Format as "Wed Jan 01 2025"
                  />
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>

      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: 2 }}>
        <IconButton onClick={handlePreviousPage} disabled={currentPage === 1}>
          <ArrowBackIcon />
        </IconButton>
        <Typography>Page {currentPage}</Typography>
        <IconButton
          onClick={handleNextPage}
          disabled={currentPage === Math.ceil(selectedItems.length / itemsPerPage)}
        >
          <ArrowForwardIcon />
        </IconButton>
      </Box>
    </div>
  );
};

export default ActionItemTable;
